import { ComponentProps } from "react";

type SweepIconProps = ComponentProps<"svg">;

const SweepIcon: React.FC<SweepIconProps> = ({ color = "#1F8475", ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M20.5 3.5L12.9 12.5" stroke={color} strokeWidth="1.85" strokeLinecap="round" />
      <path d="M11.6 11.55L14.75 14.2" stroke={color} strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.15 12.85C9.7 15.1 7.3 17.1 3.75 18.65C5.85 21.2 9.05 22.2 12.8 21.65C12.75 18.55 13.5 16.05 14.95 14.05L11.15 12.85Z"
        stroke={color}
        strokeWidth="1.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 16.2C9.7 17.65 8.2 18.85 6.35 19.75M13.05 16.55C12.4 18.05 12.1 19.65 12.15 21.35"
        stroke={color}
        strokeWidth="1.55"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SweepIcon;
